import React from 'react'
import { Image } from 'react-bootstrap';
import lekeTedavisi from '../../images/home/taniTedavi/1600172656382.jpg';
import '../../styles/about.css'

const TaniTedavi4 = () => {
    return (
        <div>
            <h5 className='main-title'>DERİ BİOPSİSİ</h5>
            <hr />
            <p>Cilt biyopsisi, vücudunuzun yüzey hücrelerinden veya deri katmanlarından örnek alma işlemidir. Biyopsi yöntemleriyle vücudunuzdan alınan deri örnekleri incelendiğinde, sağlık durumunuz hakkında bazı veriler elde edilir.</p>
            <p>Cilt biyopsisi, vücudunuzun yüzey hücrelerinden veya deri katmanlarından örnek alma işlemidir. Biyopsi yöntemleriyle vücudunuzdan alınan deri örnekleri incelendiğinde, sağlık durumunuz hakkında bazı veriler elde edilir. Doktorlar cildinizde oluşabilecek bazı deri hastalıklarını teşhis edebilmek ya da engellemek için cilt biyopsisi yöntemlerine başvurabilirler.</p>
            <p>Cilt biyopsisinin üç temel yöntemi vardır:</p>
            <Image src={lekeTedavisi} fluid className='mb-4' style={{ width: '70%' }} />
            <p><strong>Tıraş biyopsi:</strong> Doktorunuz derinizin en üst tabakasından küçük bir örnek almak için jilet benzeri bir araç kullanır.</p>
            <p><strong>Punch biyopsi:</strong> Doktorunuz dairesel bir araç kullanarak, cildinizin yüzeysel yağları da içeren nispeten derin tabakalarından küçük bir deri örneği alır.</p>
            <p><strong>Eksizyonel biyopsi:</strong> Doktorunuz, küçük bir bıçak (bisturi) kullanarak sağlıklı deriden bir parça içerecek şekilde, cildiniz üzerinde anormallik gösteren bölgenin tamamını alır.</p>
        </div>
    )
}

export default TaniTedavi4